export default __webpack_public_path__ + "static/Kevin-Resume-f170bf80f99fbd86375b7d7a41ce093b.pdf";